import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA3-UXCiSbnpsB6OboocdMObHQ6Y9WMcos",
  authDomain: "anime-surf.firebaseapp.com",
  projectId: "anime-surf",
  storageBucket: "anime-surf.appspot.com",
  messagingSenderId: "443422152997",
  appId: "1:443422152997:web:498b2c74751b0237e022cc"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);